<template>
  <div class="page_bg">
    <div class="payCopy_bg flex-c-c-s">
      <div style="width: 100%;margin-left: 0.84rem;" class="flex-r-s-s">
        <van-image width="3.59rem" height="1.11rem" style="margin-top: 0.56rem;"
                   src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/order/payCopy_logo.png"
        />
      </div>
      <div class="msg1">受微信限制，请按以下操作完成支付</div>
      <div class="msg2">点击复制，在浏览器中打开</div>
      <div style="width: 100%;" class="flex-r-c-c">
        <div class="btn" @click="copy">复 制</div>
      </div>
    </div>
  </div>
</template>

<script>
import './index.scss'
export default {
  name: 'PayCopy',
  data() {
    return {}
  },
  created() {

  },
  methods: {
    copy() {
      this.$copyText(this.$route.query.url).then(
        e => { this.$toast('复制成功!') },
        e => { this.$toast('复制失败!') }
      )
    }
  }
}
</script>

<style>
.payCopy_bg {
  width: 100%;
  height: 19.31rem;
  background: url("https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/order/payCopy_bg1.png");
  background-size: 100%;
}
.msg1 {
  font-size: 0.43rem;
  color: #333;

  margin-top: 10rem;
}
.msg2 {
  font-size: 0.43rem;
  color: #0767ab;
  margin-top: 0.16rem;
}
.btn {
  width: 6.67rem;
  height: 1.07rem;
  border-radius: 0.51rem;
  background: #0767ab;

  font-size: 0.48rem;
  line-height: 1.07rem;
  color: #fff;

  text-align: center;
  margin-top: 0.56rem;
}
</style>
